<template lang="pug">

.ge-ti
	.he-top
		router-link.he-top-logo(:to="{name: $store.state.general.lang+'.home'}")
			img(src="/acb-live.png", alt="acb live")
	
	.ge-ti-cnt-wrap: .ge-ti-cnt
		span.ge-ti-cnt__title {{ $t('El partido seleccionado no existe') }}
		span.ge-ti-cnt__desc {{ $t('Por favor busca otro partido o dirigete al calendario.') }}
		router-link(:to="{name: $store.state.general.lang+'.home'}").ge-ti-cnt__cta.ge-btn {{ $t('Volver al calendario') }}

	img.ge-ti__bg(src="/partido-no-encontrado.jpg", alt="partido no encontrado")

</template>

<script>

export default {
	name:"Error",
	methods: {
		toggleNav() {
			this.$store.commit('general/setNav', 1)
		},
	}
}

</script>